import React from 'react';
import {useStyles} from "./styles/MemberTableStyle";
import {
    Box,
    Button,
    Dialog,
    FormControl,
    FormControlLabel,
    IconButton,
    MenuItem,
    Radio,
    RadioGroup,
    Select,
    TextField,
    Typography,
} from "@material-ui/core";
import PropTypes from 'prop-types';
import clsx from "clsx";
import {ReactComponent as ArrowDownIcon} from '../../../common/images/ArrowDownIcon.svg';
import {ReactComponent as DialogCloseIcon} from '../../../common/images/DialogCloseIcon.svg';
import {inject, observer} from "mobx-react";
import {injectIntl} from "react-intl";
import {USER_TYPE} from "../../../stores/UserStore";
import {ReactComponent as WarningIcon} from "../../../common/images/WarningIcon.svg";
import {ReactComponent as SuccessIcon} from "../../../common/images/SuccessIcon.svg";
import {COMMON_UTIL} from "../../../common/util/common.util";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <div>{children}</div>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function AddMember(props) {
    const classes = useStyles();
    const {intl} = props;
    const {userStore, authStore} = props;
    const userType = authStore.getUserType();
    const open = userStore.addUserDialogOpen;
    const type = userStore.addUserDialogType;

    const handleClose = () => {
        userStore.setAddUserDialogOpen(false);
    }

    const handleChangeType = (e) => {
        userStore.setAddUserDialogType(e.target.value, userType);
    }

    const handleChangeLocaleAdminId = (e) => {
        let newLocaleAdmin = Object.assign({}, userStore.newLocaleAdmin);
        newLocaleAdmin.id = String(e.target.value).trim();
        userStore.setNewLocaleAdmin(newLocaleAdmin);
        userStore.setDuplicateIdState('None');
    }

    const handleChangeGroupUserId = (e) => {
        let newGroupUser = Object.assign({}, userStore.newGroupUser);
        newGroupUser.id = String(e.target.value).trim();
        userStore.setNewGroupUser(newGroupUser);
        userStore.setDuplicateIdState('None');
    }

    const handleChangeLocaleAdminPassword = (e) => {
        let newLocaleAdmin = Object.assign({}, userStore.newLocaleAdmin);
        newLocaleAdmin.password = String(e.target.value).trim();
        userStore.setNewLocaleAdmin(newLocaleAdmin);
    }

    const handleChangeGroupUserPassword = (e) => {
        let newGroupUser = Object.assign({}, userStore.newGroupUser);
        newGroupUser.password = String(e.target.value).trim();
        userStore.setNewGroupUser(newGroupUser);
    }

    const handleChangeLocaleAdminLocaleCode = (e) => {
        let newLocaleAdmin = Object.assign({}, userStore.newLocaleAdmin);
        newLocaleAdmin.localeCode = e.target.value;
        userStore.setNewLocaleAdmin(newLocaleAdmin);
    }

    const handleChangeGroupUserLocaleCode = (e) => {
        const localeCode = e.target.value;
        let newGroupUser = Object.assign({}, userStore.newGroupUser);
        newGroupUser.localeCode = localeCode;
        newGroupUser.localeAdminUserId = ' ';
        newGroupUser.localeGroupType = ' ';
        newGroupUser.localeGroupId = ' ';
        userStore.setNewGroupUser(newGroupUser);

        if (localeCode === ' ') {
            userStore.setLocaleAdminUserIdList([]);
        } else {
            userStore.getLocaleAdminUserIdList(localeCode);
        }
    }

    const handleChangeGroupUserLocaleAdminUserId = (e) => {
        const localeAdminUserId = e.target.value;
        let newGroupUser = Object.assign({}, userStore.newGroupUser);
        newGroupUser.localeAdminUserId = localeAdminUserId;
        newGroupUser.localeGroupType = ' ';
        newGroupUser.localeGroupId = ' ';
        userStore.setNewGroupUser(newGroupUser);

        if (localeAdminUserId === ' ') {
            userStore.setLocaleGroupList([]);
        } else {
            userStore.getLocaleGroupList(localeAdminUserId);
        }
    }

    const handleChangeGroupUserLocaleGroupType = (e) => {
        const groupType = e.target.value;
        let newGroupUser = Object.assign({}, userStore.newGroupUser);
        newGroupUser.localeGroupType = groupType;
        newGroupUser.localeGroupId = ' ';
        userStore.setNewGroupUser(newGroupUser);
    }

    const handleChangeGroupUserLocaleGroupName = (e) => {
        let newGroupUser = Object.assign({}, userStore.newGroupUser);
        newGroupUser.localeGroupId = e.target.value;

        userStore.setNewGroupUser(newGroupUser);

        if (type === 'Normal') {
            userStore.getGroupConfigs(newGroupUser.localeGroupId, () => {
                newGroupUser = Object.assign({}, userStore.newGroupUser);

                const defaultEmailConfig = userStore.localeGroupConfigList.find(config => config.configKey === 'DefaultEmail');
                if (defaultEmailConfig && userStore.newGroupUserSecondId === '') {
                    const defaultEmail = defaultEmailConfig.value;
                    userStore.setNewGroupUserSecondId(defaultEmail);
                }

                const defaultPasswordConfig = userStore.localeGroupConfigList.find(config => config.configKey === 'DefaultPassword');
                if (defaultPasswordConfig && newGroupUser.password === '') {
                    newGroupUser.password = defaultPasswordConfig.value;
                }

                userStore.setNewGroupUser(newGroupUser);
            });
        }
    }

    const handleChangeLocaleAdminEmail = (e) => {
        let newLocaleAdmin = Object.assign({}, userStore.newLocaleAdmin);
        newLocaleAdmin.email = String(e.target.value).trim();
        userStore.setNewLocaleAdmin(newLocaleAdmin);
    }

    const handleChangeGroupUserEmail = (e) => {
        let newGroupUser = Object.assign({}, userStore.newGroupUser);
        newGroupUser.email = String(e.target.value).trim();
        userStore.setNewGroupUser(newGroupUser);
    }

    const handleChangeGroupUserName = (e) => {
        let newGroupUser = Object.assign({}, userStore.newGroupUser);
        newGroupUser.name = String(e.target.value).trim();
        userStore.setNewGroupUser(newGroupUser);
    }

    const handleChangeGroupUserFirstId = (e) => {
        const id = String(e.target.value).trim();
        userStore.setNewGroupUserFirstId(id);
    }

    const handleChangeGroupUserSecondId = (e) => {
        const id = String(e.target.value).trim();
        userStore.setNewGroupUserSecondId(id);
    }

    const handleClickRandomPassword = () => {
        const randomPassword = String(Math.floor(1000 + Math.random() * 9000));

        switch (type) {
            case 'LocaleAdmin':
                let newLocaleAdmin = Object.assign({}, userStore.newLocaleAdmin);
                newLocaleAdmin.password = randomPassword;
                userStore.setNewLocaleAdmin(newLocaleAdmin);
                break;
            default:
                let newGroupUser = Object.assign({}, userStore.newGroupUser);
                newGroupUser.password = randomPassword;
                userStore.setNewGroupUser(newGroupUser);
                break;
        }
    }

    const handleCheckIdDuplicate = (id) => {
        userStore.checkIdDuplicate(id);
    }

    const isCompleteForm = () => {
        if (userStore.duplicateIdState !== 'Success') {
            return false;
        }
        switch (type) {
            case 'LocaleAdmin':
                return userStore.isCompleteNewLocaleAdminForm();
            default:
                return userStore.isCompleteNewGroupUserForm();
        }
    }

    const handleClickCreateUser = () => {
        switch (type) {
            case 'LocaleAdmin':
                userStore.addLocaleAdminUser(authStore.loginUser.id);
                break;
            default:
                userStore.addGroupUser(intl, authStore.loginUser.id);
                break;
        }
    }

    return (
        <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={open} className={classes.dialogWrap}>
            <Box className={classes.myPageBox}>
                <Box className={classes.titleDialog} variant="contained" color="primary" display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                    <Typography>{intl.formatMessage({id: "create_account"})}</Typography>
                    <IconButton className={classes.iconButton} disableRipple onClick={handleClose}>
                        <DialogCloseIcon />
                    </IconButton>
                </Box>
                <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                    <Typography className={classes.myPageTitle}>{intl.formatMessage({id: "type"})}<span>*</span></Typography>
                    <FormControl component="fieldset" className={classes.typeAccount}>
                        <RadioGroup row aria-label="type" name="type" value={type} onChange={handleChangeType}>
                            {userType === USER_TYPE.Admin &&
                                <FormControlLabel value="LocaleAdmin" control={<Radio />} label={intl.formatMessage({id: "LocaleAdmin"})} />
                            }
                            {userType !== USER_TYPE.GroupAdmin &&
                                <FormControlLabel value="GroupAdmin" control={<Radio />} label={intl.formatMessage({id: "GroupAdmin"})} />
                            }
                            <FormControlLabel value="Normal" control={<Radio />} label={intl.formatMessage({id: "Normal"})} />
                        </RadioGroup>
                    </FormControl>
                </Box>
                <div>
                    {type === 'LocaleAdmin' &&
                        <div>
                            <Box style={userStore.duplicateIdState !== 'None' ? {marginBottom: 0} : null} display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                <Typography className={classes.myPageTitle}>ID<span>*</span></Typography>
                                <Box className={classes.emailBox} display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                                    <TextField id="outlined-basic" variant="outlined" placeholder={intl.formatMessage({id: "id"})} value={userStore.newLocaleAdmin.id} onChange={handleChangeLocaleAdminId}/>
                                    <Button className={(userStore.newLocaleAdmin.id === '' || userStore.duplicateIdState === 'Success') ? classes.disabledBtn : classes.accountBtn2} disableRipple onClick={() => handleCheckIdDuplicate(userStore.newLocaleAdmin.id)} disabled={userStore.newLocaleAdmin.id === '' || userStore.duplicateIdState === 'Success'}>
                                        <Typography>{intl.formatMessage({id: "duplicate_check"})}</Typography>
                                    </Button>
                                </Box>
                            </Box>
                            {userStore.duplicateIdState === 'Fail' &&
                                <Box className={classes.noticeText} display={"flex"} justifyContent={"center"} alignItems={"center"}>
                                    <WarningIcon /><Typography>{intl.formatMessage({id: "msg_info_duplicate_id"})}</Typography>
                                </Box>
                            }
                            {userStore.duplicateIdState === 'Success' &&
                                <Box className={classes.noticeText} display={"flex"} justifyContent={"center"} alignItems={"center"}>
                                    <SuccessIcon /><Typography style={{color: '#1554F6'}}>{intl.formatMessage({id: "msg_info_available_id"})}</Typography>
                                </Box>
                            }
                            <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                <Typography className={classes.myPageTitle}>{intl.formatMessage({id: "password"})}<span>*</span></Typography>
                                <Box className={classes.emailBox} >
                                    <TextField id="outlined-basic" variant="outlined" placeholder={intl.formatMessage({id: "password"})} value={userStore.newLocaleAdmin.password} onChange={handleChangeLocaleAdminPassword} />
                                    <Button className={classes.accountBtn2} disableRipple onClick={handleClickRandomPassword}>
                                        <Typography>{intl.formatMessage({id: "generate_random"})}</Typography>
                                    </Button>
                                </Box>
                            </Box>
                            <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                <Typography className={classes.myPageTitle}>{intl.formatMessage({id: "Locale"})}<span>*</span></Typography>
                                <FormControl className={classes.formControlAccount}>
                                    <Select
                                        value={userStore.newLocaleAdmin.localeCode}
                                        onChange={handleChangeLocaleAdminLocaleCode}
                                        IconComponent={(props) => (
                                            <Box>
                                                <ArrowDownIcon  {...props} />
                                            </Box>
                                        )}
                                        MenuProps={{
                                            anchorOrigin: {
                                                vertical: "bottom",
                                                horizontal: "right"
                                            },
                                            transformOrigin:{
                                                vertical: 'top',
                                                horizontal: 'right',
                                            },
                                            getContentAnchorEl: null,
                                            className:classes.selectPopover
                                        }}
                                    >
                                        {userStore.newLocaleAdmin.localeCode === ' ' &&
                                            <MenuItem value=' '>{intl.formatMessage({id: "msg_info_select_locale"})}</MenuItem>
                                        }
                                        {COMMON_UTIL.getLocaleList().map((locale, index) => (
                                            <MenuItem key={index} value={locale}>{intl.formatMessage({id: locale})}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Box>
                            <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                <Typography className={classes.myPageTitle}>{intl.formatMessage({id: "email"})}</Typography>
                                <Box className={classes.emailBox} >
                                    <TextField id="outlined-basic" variant="outlined" placeholder={intl.formatMessage({id: "email"})} value={userStore.newLocaleAdmin.email} onChange={handleChangeLocaleAdminEmail}/>
                                </Box>
                            </Box>
                        </div>
                    }
                    {type === 'GroupAdmin' &&
                        <div>
                            <Box style={userStore.duplicateIdState !== 'None' ? {marginBottom: 0} : null} display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                <Typography className={classes.myPageTitle}>ID<span>*</span></Typography>
                                <Box className={classes.emailBox} >
                                    <TextField id="outlined-basic" variant="outlined" placeholder={intl.formatMessage({id: "id"})} value={userStore.newGroupUser.id} onChange={handleChangeGroupUserId}/>
                                    <Button className={(userStore.newGroupUser.id === '' || userStore.duplicateIdState === 'Success') ? classes.disabledBtn : classes.accountBtn2} disableRipple onClick={() => handleCheckIdDuplicate(userStore.newGroupUser.id)} disabled={userStore.newGroupUser.id === '' || userStore.duplicateIdState === 'Success'}>
                                        <Typography>{intl.formatMessage({id: "duplicate_check"})}</Typography>
                                    </Button>
                                </Box>
                            </Box>
                            {userStore.duplicateIdState === 'Fail' &&
                                <Box className={classes.noticeText} display={"flex"} justifyContent={"center"} alignItems={"center"}>
                                    <WarningIcon /><Typography>{intl.formatMessage({id: "msg_info_duplicate_id"})}</Typography>
                                </Box>
                            }
                            {userStore.duplicateIdState === 'Success' &&
                                <Box className={classes.noticeText} display={"flex"} justifyContent={"center"} alignItems={"center"}>
                                    <SuccessIcon /><Typography style={{color: '#1554F6'}}>{intl.formatMessage({id: "msg_info_available_id"})}</Typography>
                                </Box>
                            }
                            <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                <Typography className={classes.myPageTitle}>{intl.formatMessage({id: "password"})}<span>*</span></Typography>
                                <Box className={classes.emailBox} >
                                    <TextField id="outlined-basic" variant="outlined" placeholder={intl.formatMessage({id: "password"})} value={userStore.newGroupUser.password} onChange={handleChangeGroupUserPassword} />
                                    <Button className={classes.accountBtn2} disableRipple onClick={handleClickRandomPassword}>
                                        <Typography>{intl.formatMessage({id: "generate_random"})}</Typography>
                                    </Button>
                                </Box>
                            </Box>
                            {userType === USER_TYPE.Admin &&
                                <>
                                    <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                        <Typography className={classes.myPageTitle}>{intl.formatMessage({id: "Locale"})}<span>*</span></Typography>
                                        <FormControl className={classes.formControlAccount}>
                                            <Select
                                                value={userStore.newGroupUser.localeCode}
                                                onChange={handleChangeGroupUserLocaleCode}
                                                IconComponent={(props) => (
                                                    <Box>
                                                        <ArrowDownIcon  {...props} />
                                                    </Box>
                                                )}
                                                MenuProps={{
                                                    anchorOrigin: {
                                                        vertical: "bottom",
                                                        horizontal: "right"
                                                    },
                                                    transformOrigin:{
                                                        vertical: 'top',
                                                        horizontal: 'right',
                                                    },
                                                    getContentAnchorEl: null,
                                                    className:classes.selectPopover
                                                }}
                                            >
                                                {userStore.newGroupUser.localeCode === ' ' &&
                                                    <MenuItem value=' '>{intl.formatMessage({id: "msg_info_select_locale"})}</MenuItem>
                                                }
                                                {COMMON_UTIL.getLocaleList().map((locale, index) => (
                                                    <MenuItem key={index} value={locale}>{intl.formatMessage({id: locale})}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Box>
                                    <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                        <Typography className={classes.myPageTitle}>{intl.formatMessage({id: "LocaleAdmin"})}<span>*</span></Typography>
                                        <FormControl className={classes.formControlAccount}>
                                            <Select
                                                value={userStore.newGroupUser.localeAdminUserId}
                                                onChange={handleChangeGroupUserLocaleAdminUserId}
                                                IconComponent={(props) => (
                                                    <Box>
                                                        <ArrowDownIcon  {...props} />
                                                    </Box>
                                                )}
                                                MenuProps={{
                                                    anchorOrigin: {
                                                        vertical: "bottom",
                                                        horizontal: "right"
                                                    },
                                                    transformOrigin:{
                                                        vertical: 'top',
                                                        horizontal: 'right',
                                                    },
                                                    getContentAnchorEl: null,
                                                    className:classes.selectPopover
                                                }}
                                            >
                                                {userStore.newGroupUser.localeAdminUserId === ' ' &&
                                                    <MenuItem value=' '>{intl.formatMessage({id: "msg_info_select_admin"})}</MenuItem>
                                                }
                                                {userStore.localeAdminUserIdList.length > 0 &&
                                                    userStore.localeAdminUserIdList.map((userId, index) => (
                                                        <MenuItem key={index} value={userId}>{userId}</MenuItem>
                                                    ))}
                                            </Select>
                                        </FormControl>
                                    </Box>
                                </>
                            }
                            {userType !== USER_TYPE.GroupAdmin &&
                                <>
                                    <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                        <Typography className={classes.myPageTitle}>{intl.formatMessage({id: "group_type"})}<span>*</span></Typography>
                                        <FormControl className={classes.formControlAccount}>
                                            <Select
                                                value={userStore.newGroupUser.localeGroupType}
                                                onChange={handleChangeGroupUserLocaleGroupType}
                                                IconComponent={(props) => (
                                                    <Box>
                                                        <ArrowDownIcon  {...props} />
                                                    </Box>
                                                )}
                                                MenuProps={{
                                                    anchorOrigin: {
                                                        vertical: "bottom",
                                                        horizontal: "right"
                                                    },
                                                    transformOrigin:{
                                                        vertical: 'top',
                                                        horizontal: 'right',
                                                    },
                                                    getContentAnchorEl: null,
                                                    className:classes.selectPopover
                                                }}
                                            >
                                                {userStore.newGroupUser.localeGroupType === ' ' &&
                                                    <MenuItem value=' '>{intl.formatMessage({id: "msg_info_select_group_type"})}</MenuItem>
                                                }
                                                {userStore.localeGroupList.length > 0 &&
                                                    userStore.getGroupTypeList().map((type, index) => (
                                                        <MenuItem key={index} value={type}>{intl.formatMessage({id: type})}</MenuItem>
                                                    ))
                                                }
                                            </Select>
                                        </FormControl>
                                    </Box>
                                    <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                        <Typography className={classes.myPageTitle}>{intl.formatMessage({id: "group_name"})}<span>*</span></Typography>
                                        <FormControl className={classes.formControlAccount}>
                                            <Select
                                                value={userStore.newGroupUser.localeGroupId}
                                                onChange={handleChangeGroupUserLocaleGroupName}
                                                IconComponent={(props) => (
                                                    <Box>
                                                        <ArrowDownIcon  {...props} />
                                                    </Box>
                                                )}
                                                MenuProps={{
                                                    anchorOrigin: {
                                                        vertical: "bottom",
                                                        horizontal: "right"
                                                    },
                                                    transformOrigin:{
                                                        vertical: 'top',
                                                        horizontal: 'right',
                                                    },
                                                    getContentAnchorEl: null,
                                                    className:classes.selectPopover
                                                }}
                                            >
                                                {userStore.newGroupUser.localeGroupId === ' ' &&
                                                    <MenuItem value=' '>{intl.formatMessage({id: "msg_info_select_group"})}</MenuItem>
                                                }
                                                {userStore.localeGroupList.length > 0 &&
                                                    userStore.getGroupList(userStore.newGroupUser.localeGroupType).map((group, index) => (
                                                        <MenuItem key={index} value={group.id}>{group.name}</MenuItem>
                                                    ))
                                                }
                                            </Select>
                                        </FormControl>
                                    </Box>
                                </>
                            }
                            <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                <Typography className={classes.myPageTitle}>{intl.formatMessage({id: "email"})}</Typography>
                                <Box className={classes.emailBox} >
                                    <TextField id="outlined-basic" variant="outlined" placeholder={intl.formatMessage({id: "email"})} value={userStore.newGroupUser.email} onChange={handleChangeGroupUserEmail}/>
                                </Box>
                            </Box>
                        </div>
                    }
                    {type === 'Normal' &&
                        <div>
                            {userType === USER_TYPE.Admin &&
                                <>
                                    <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                        <Typography className={classes.myPageTitle}>{intl.formatMessage({id: "Locale"})}<span>*</span></Typography>
                                        <FormControl className={classes.formControlAccount}>
                                            <Select
                                                value={userStore.newGroupUser.localeCode}
                                                onChange={handleChangeGroupUserLocaleCode}
                                                IconComponent={(props) => (
                                                    <Box>
                                                        <ArrowDownIcon  {...props} />
                                                    </Box>
                                                )}
                                                MenuProps={{
                                                    anchorOrigin: {
                                                        vertical: "bottom",
                                                        horizontal: "right"
                                                    },
                                                    transformOrigin:{
                                                        vertical: 'top',
                                                        horizontal: 'right',
                                                    },
                                                    getContentAnchorEl: null,
                                                    className:classes.selectPopover
                                                }}
                                            >
                                                {userStore.newGroupUser.localeCode === ' ' &&
                                                    <MenuItem value=' '>{intl.formatMessage({id: "msg_info_select_locale"})}</MenuItem>
                                                }
                                                {COMMON_UTIL.getLocaleList().map((locale, index) => (
                                                    <MenuItem key={index} value={locale}>{intl.formatMessage({id: locale})}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Box>
                                    <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                        <Typography className={classes.myPageTitle}>{intl.formatMessage({id: "LocaleAdmin"})}<span>*</span></Typography>
                                        <FormControl className={classes.formControlAccount}>
                                            <Select
                                                value={userStore.newGroupUser.localeAdminUserId}
                                                onChange={handleChangeGroupUserLocaleAdminUserId}
                                                IconComponent={(props) => (
                                                    <Box>
                                                        <ArrowDownIcon  {...props} />
                                                    </Box>
                                                )}
                                                MenuProps={{
                                                    anchorOrigin: {
                                                        vertical: "bottom",
                                                        horizontal: "right"
                                                    },
                                                    transformOrigin:{
                                                        vertical: 'top',
                                                        horizontal: 'right',
                                                    },
                                                    getContentAnchorEl: null,
                                                    className:classes.selectPopover
                                                }}
                                            >
                                                {userStore.newGroupUser.localeAdminUserId === ' ' &&
                                                    <MenuItem value=' '>{intl.formatMessage({id: "msg_info_select_admin"})}</MenuItem>
                                                }
                                                {userStore.localeAdminUserIdList.length > 0 &&
                                                    userStore.localeAdminUserIdList.map((userId, index) => (
                                                        <MenuItem key={index} value={userId}>{userId}</MenuItem>
                                                    ))}
                                            </Select>
                                        </FormControl>
                                    </Box>
                                </>
                            }
                            {userType !== USER_TYPE.GroupAdmin &&
                                <>
                                    <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                        <Typography className={classes.myPageTitle}>{intl.formatMessage({id: "group_type"})}<span>*</span></Typography>
                                        <FormControl className={classes.formControlAccount}>
                                            <Select
                                                value={userStore.newGroupUser.localeGroupType}
                                                onChange={handleChangeGroupUserLocaleGroupType}
                                                IconComponent={(props) => (
                                                    <Box>
                                                        <ArrowDownIcon  {...props} />
                                                    </Box>
                                                )}
                                                MenuProps={{
                                                    anchorOrigin: {
                                                        vertical: "bottom",
                                                        horizontal: "right"
                                                    },
                                                    transformOrigin:{
                                                        vertical: 'top',
                                                        horizontal: 'right',
                                                    },
                                                    getContentAnchorEl: null,
                                                    className:classes.selectPopover
                                                }}
                                            >
                                                {userStore.newGroupUser.localeGroupType === ' ' &&
                                                    <MenuItem value=' '>{intl.formatMessage({id: "msg_info_select_group_type"})}</MenuItem>
                                                }
                                                {userStore.localeGroupList.length > 0 &&
                                                    userStore.getGroupTypeList().map((type, index) => (
                                                        <MenuItem key={index} value={type}>{intl.formatMessage({id: type})}</MenuItem>
                                                    ))
                                                }
                                            </Select>
                                        </FormControl>
                                    </Box>
                                    <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                        <Typography className={classes.myPageTitle}>{intl.formatMessage({id: "group_name"})}<span>*</span></Typography>
                                        <FormControl className={classes.formControlAccount}>
                                            <Select
                                                value={userStore.newGroupUser.localeGroupId}
                                                onChange={handleChangeGroupUserLocaleGroupName}
                                                IconComponent={(props) => (
                                                    <Box>
                                                        <ArrowDownIcon  {...props} />
                                                    </Box>
                                                )}
                                                MenuProps={{
                                                    anchorOrigin: {
                                                        vertical: "bottom",
                                                        horizontal: "right"
                                                    },
                                                    transformOrigin:{
                                                        vertical: 'top',
                                                        horizontal: 'right',
                                                    },
                                                    getContentAnchorEl: null,
                                                    className:classes.selectPopover
                                                }}
                                            >
                                                {userStore.newGroupUser.localeGroupId === ' ' &&
                                                    <MenuItem value=' '>{intl.formatMessage({id: "msg_info_select_group"})}</MenuItem>
                                                }
                                                {userStore.localeGroupList.length > 0 &&
                                                    userStore.getGroupList(userStore.newGroupUser.localeGroupType).map((group, index) => (
                                                        <MenuItem key={index} value={group.id}>{group.name}</MenuItem>
                                                    ))
                                                }
                                            </Select>
                                        </FormControl>
                                    </Box>
                                </>
                            }
                            <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                <Typography className={classes.myPageTitle}>ID({intl.formatMessage({id: "email"})})<span>*</span></Typography>
                                <Box className={classes.emailTwoBox} display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                    <TextField id="outlined-basic" variant="outlined" placeholder={intl.formatMessage({id: "id"})} value={userStore.newGroupUserFirstId} onChange={handleChangeGroupUserFirstId}/>
                                    <span>@</span>
                                    <TextField id="outlined-basic" variant="outlined" placeholder={intl.formatMessage({id: "id"})} value={userStore.newGroupUserSecondId} onChange={handleChangeGroupUserSecondId}/>
                                    <Button className={(userStore.newGroupUserFirstId === '' || userStore.newGroupUserSecondId === '' || userStore.duplicateIdState === 'Success') ? classes.disabledBtn : classes.accountBtn2} disableRipple onClick={() => handleCheckIdDuplicate(userStore.newGroupUser.id)} disabled={userStore.newGroupUserFirstId === '' || userStore.newGroupUserSecondId === '' || userStore.duplicateIdState === 'Success'}>
                                        <Typography>{intl.formatMessage({id: "duplicate_check"})}</Typography>
                                    </Button>
                                </Box>
                            </Box>
                            {userStore.duplicateIdState === 'Fail' &&
                                <Box className={classes.noticeText} display={"flex"} justifyContent={"center"} alignItems={"center"}>
                                    <WarningIcon /><Typography>{intl.formatMessage({id: "msg_info_duplicate_id"})}</Typography>
                                </Box>
                            }
                            {userStore.duplicateIdState === 'Success' &&
                                <Box className={classes.noticeText} display={"flex"} justifyContent={"center"} alignItems={"center"}>
                                    <SuccessIcon /><Typography style={{color: '#1554F6'}}>{intl.formatMessage({id: "msg_info_available_id"})}</Typography>
                                </Box>
                            }
                            <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                <Typography className={classes.myPageTitle}>{intl.formatMessage({id: "password"})}<span>*</span></Typography>
                                <Box className={classes.emailBox} >
                                    <TextField id="outlined-basic" variant="outlined" placeholder={intl.formatMessage({id: "password"})} value={userStore.newGroupUser.password} onChange={handleChangeGroupUserPassword} />
                                    <Button className={classes.accountBtn2} disableRipple onClick={handleClickRandomPassword}>
                                        <Typography>{intl.formatMessage({id: "generate_random"})}</Typography>
                                    </Button>
                                </Box>
                            </Box>

                            <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                <Typography className={classes.myPageTitle}>{intl.formatMessage({id: "name"})}<span>*</span></Typography>
                                <Box className={classes.emailBox} >
                                    <TextField id="outlined-basic" variant="outlined" placeholder={intl.formatMessage({id: "name"})} value={userStore.newGroupUser.name} onChange={handleChangeGroupUserName}/>
                                </Box>
                            </Box>
                        </div>
                    }
                </div>
            </Box>
            <Box className={classes.groupBtn}>
                <Button className={isCompleteForm() ? clsx(classes.inputButton, classes.inputButtonActive) : classes.inputButton} disableRipple disabled={!isCompleteForm()} onClick={handleClickCreateUser}>
                    <Typography>{intl.formatMessage({id: "create"})}</Typography>
                </Button>
            </Box>
        </Dialog>
    );
}

export default inject('userStore', 'authStore')(injectIntl(observer(AddMember)));
